import { Link } from 'components/index';
import { useGTMWidgets } from 'hooks/utilities/useGTMWidgets';
import { useTranslation } from 'react-i18next';
import styles from './FooterCookieAccessibility.module.scss';

const FooterCookieAccessibility = () => {
  const { t } = useTranslation('footer');
  const { showAccessibility, showCookie } = useGTMWidgets();
  return (
    <div className={styles.container} data-test="footer-cookie-accessibility">
      <p className={`${styles['helper-text']} ${styles['helper-text-link']}`}>
        <Link
          className={styles['cookie-accessibility-link']}
          dataTest="footer-cookie-settings"
          onClick={showCookie}
        >
          {t('cookie_settings')}
        </Link>
        <span className={styles['helper-separator']}>|</span>
        <Link
          className={styles['cookie-accessibility-link']}
          dataTest="footer-accessibility-settings"
          onClick={showAccessibility}
        >
          {t('accessibility_settings')}
        </Link>
      </p>
    </div>
  );
};

export default FooterCookieAccessibility;
